import ApiBase from '../ApiBase';

class Overtime extends ApiBase {
  /**
   * @method fetch
   * @param {number} page
   * @return {Promise<*>}
   */
  fetch = (page) => {
    return this.get('time/overtimes', {
      page,
    });
  };

  /**
   * @method create
   * @param {objective} data
   * @return {Promise<*>}
   */
  create = (data) => {
    return this.post('time/overtimes', data, 'create');
  };

  /**
   * @method remove
   * @param {string} id
   * @return {Promise<*>}
   */
  remove = (id) => {
    return this.delete(`time/overtimes/${id}`, {}, 'delete');
  };

  /**
   * @method fetchApprovals
   * @param {number} page
   * @return {Promise<*>}
   */
  fetchApprovals = (page) => {
    return this.get('time/overtime-approvals', {
      page,
    });
  };

  /**
   * @method reviewerUpdate
   * @param {string} id
   * @param {object} data
   * @return {Promise<*>}
   */
  reviewerUpdate = (id, data) => {
    return this.patch(`time/overtime-approvals/${id}`, data);
  };
}

export default new Overtime();
